export default "__VITE_ASSET__DtDWitAA__"